import React, { useState } from "react";
import BusinessSearchNDetails from "../../../../../components/common/forms/BusinessSearchNDetails";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../../components/common/forms/FormButtom";
import FormPayment from "../../../../../components/common/forms/FormPayment";
import { upload_document } from "./Share_Lagat_Provide_Form";
import { useForm } from "react-hook-form";
import Documents from "../../../../../components/common/forms/Documents";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import api, { url } from "../../../../../api/api";
import { toast } from "react-toastify";
import NewFormPayment from "../../../../../components/common/forms/NewFormPayment";

const OldShareLegatForm = () => {
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);
  const [cmpId, setCmpId] = useState(null);
  const [turnOn, setTurnOn] = useState(true);
  const [uploadProof, setUploadProof] = useState('')

  const handleClick = (data) => {
    // data.share_holders = shareHolders
    data.company = cmpId;
    data.documents = docsOutput;
    data.amendment_type = "share_lagat";
    // console.log(data)

    const user = JSON.parse(localStorage.getItem("user"));

    api
      .post("services/company/amendments/", data)
      .then((response) => {
        toast.success("Data Registered Successfully");
        // let transactions = {
        //   // payment_mode: "e_wallet",
        //   amount: 2500,
        //   service_object_id: response.data.service_object_id,
        //   created_by: response.data.service_object_id,
        //   service_object_content_type: response.data.service_content_type_id,
        //   payment_proof : uploadProof,
        //   company : cmpId,
        //   transaction_type: "credit"
       
        // };

        // api
        //   .post("/transactions/", transactions)
        //   .then((response) => {
        //     toast.success("Data Registered 2 Successfully.");
        //   })
        //   .catch((error) => {
        //     toast.error("Error in Transaction");
        //   });
      })
      .catch((error) => {
        // console.log("error", error);
        toast.error("Something went wrong");
      });
  };

  let data = [];
  upload_document.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  return (
    <form>
      <div className="flex justify-between">
        <p className="text-primary-blue font-Calistoga text-lg underline">
          1. Business Name & Other Details
        </p>
      </div>

      {/* company name and other details */}
      <BusinessSearchNDetails setCmpId={setCmpId} />
      {/* compnay name and other details close */}

      <div className="border-2 bg-pink-100 border-primary-blue border-t-0">
        <p className="text-primary-blue mt-0 font-Laila text-lg font-semibold leading-10 text-center">
          शेयर सदस्यहरुको संख्याको आधारमा शेयर लगत निकाल्दा तपाईको जम्मा लाग्ने
          रकम रु.१२,०००।– मात्र
        </p>
      </div>

      {/* upload documents open */}
      <div className="text-primary-blue font-Calistoga text-lg underline my-4">
        2. Upload Document <span className="text-primary-blue font-Laila underline"> (शेयर लगत निकाल्नको लागि आवश्यक पर्ने निम्न कागजपत्रहरु ग्उयिबम गर्नुहोस ।) </span>
      </div>

      {/* upload documents close */}
      {/* upload documents close */}
      <Documents
        documents_data={upload_document}
        initialState={data}
        setDocument={setDocsOutput}
      />
 <div className="text-primary-blue font-Calistoga text-lg my-5 mb-6 underline">
              3. Working Branch
              <span className="text-primary-blue ont-Laila underline mx-2 ">
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>
      <FormBranch register={register} name={"working_branch"} />
      <FormButtom />
       
       <NewFormPayment handleSubmit={handleSubmit} handleClick={handleClick} 
       setUploadProof={setUploadProof}
       /> 
    </form>
  );
};

export default OldShareLegatForm;
